<template>
  <div v-if="can('list-user')">
    <h2>User Staff</h2>
    <div class="list-table">
      <div class="col-md-12">
        <div class="block-right col-md-2">
          <div class="btn-group float-right" style="margin-bottom: 5px">
            <input
              type="text"
              class="float-right form-control"
              style="margin: 0px"
              placeholder="Search"
              v-model="query"
              v-on:keyup.enter="searchUser()"
            />
            <span
              class="fa fa-search btn btn-success"
              style="cursor: pointer"
              v-on:click="searchUser()"
            />
          </div>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Sort</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in userList" :key="data.id">
            <td>{{ data.name }}</td>
            <td>{{ data.email }}</td>
            <td>{{ data.sort }}</td>
            <td v-html="statusHtml(data.status)"></td>
            <td>
              <router-link
                class=""
                :to="{
                  name: 'EditUser',
                  params: {
                    id: data.id,
                  },
                }"
                ><i class="fa fa-edit text-warning" title="Edit"></i
              ></router-link>

              <i
                style="cursor: pointer"
                title="Delete"
                class="fa ps-3 fa-trash text-danger"
                v-if="data.status == 0"
                @click="deleteUser(data.id)"
              ></i
              >&nbsp;
              <router-link
                class="fa fa-user-plus text-primary"
                title="Assign Role"
                :to="{
                  name: 'AssignRoleTouser',
                  params: {
                    id: data.id,
                  },
                }"
              ></router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-md-6">
          <select class="form-control" v-model="currentPage">
            <option v-for="i in lastPage" :key="i" :value="i">
              Jump To Page {{ i }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <paginate
            class="block-right"
            containerClass="pagination"
            pageLinkClass="page-link"
            pageClass="page-item"
            prev-text="Prev"
            next-text="Next"
            prev-link-class="page-link"
            next-link-class="page-link"
            :page-count="lastPage"
            :click-handler="paginationClickHandler"
            v-model="currentPage"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "UserList",

  data() {
    return {
      submitting: false,
      userList: [],
      lastPage: 1,
      query: "",
      currentPage: 1,
    };
  },
  mounted() {
    this.isLoading(true);

    // if (this.can("list-user")) {
    this.getUserList();
    // } else {
    //   this.$router.push({
    //     name: "Dashboard",
    //   });
    // }
  },
  methods: {
    paginationClickHandler(pageNum) {
      this.currentPage = pageNum;
      this.getUserList();
    },
    searchUser() {
      this.currentPage = 1;
      this.getUserList();
    },
    getUserList() {
      this.$http
        .get(`user?page=${this.currentPage}&q=${this.query}`)
        .then((res) => {
          if (res.data.status == 1) {
            this.userList = res.data.data.data;
            this.lastPage = res.data.data.last_page;
            this.isLoading(false);
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        });
    },
    ...mapMutations({
      isLoading: "loading",
    }),
    deleteUser(id) {
      this.$http
        .delete(`user/${id}`)
        .then((res) => {
          if (res.data.status == 1) {
            this.$notify({
              group: "notifications",
              title: "User",
              type: "error",
              text: res.data.message,
            });
            this.getUserList();
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
  watch: {
    currentPage: function () {
      this.getUserList();
    },
  },
};
</script>
